import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SidebarComponent } from './sidebar/sidebar';
import { RouterModule } from '@angular/router';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { HeaderAdminComponent } from './header/header';

@NgModule({
  imports: [CommonModule, RouterModule, NgbTooltipModule],
  declarations: [SidebarComponent, HeaderAdminComponent],
  exports: [SidebarComponent, HeaderAdminComponent],
})
export class AdminLayoutModule {}
